export const AWS_REGION = process.env.REACT_APP_AWS_REGION
// export const APP_INSTANCE_ARN = process.env.REACT_APP_APP_INSTANCE_ARN
export const UI_ENV = process.env.REACT_APP_ENV